module.exports = __webpack_public_path__ + "img/filter.1bf91545.svg";